import React from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import { cn } from '../../lib/utils'

interface LogoIconProps {
  className?: string
  alt?: string
}

export const LogoIcon: React.FC<LogoIconProps> = ({ 
  className = "h-8 w-8 transition-transform group-hover:scale-105",
  alt = "Open1031"
}) => {
  const { resolvedTheme } = useTheme()
  // Use icon.png and apply CSS filter to make it white in dark mode
  const iconSrc = '/icon.png'

  return (
    <img 
      src={iconSrc} 
      alt={alt} 
      className={cn(
        className,
        resolvedTheme === 'dark' && 'brightness-0 invert' // Makes icon white in dark mode
      )}
    />
  )
}

